import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"svg-icon",class:{[`${_vm.color}--text`]: true, 'mx-auto': _vm.center}},[(_vm.icon === 'success')?_c('success-icon'):(_vm.icon === 'info')?_c('info-icon'):(_vm.icon === 'error')?_c('error-icon'):_c(VIcon,{attrs:{"color":_vm.color,"size":"60"}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }